import {defineStore} from "pinia";
export const sancionStore = defineStore("sancionStore", {
    state: () =>
        ({
            loading: false as boolean,
            cliente: [] as any[],
            sanciones: [] as any[],
            cuotas: [] as any[],
            sancion: [] as any[],
            sancionNueva: [] as any[],
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            showDialogSancion: false as boolean,
            isNew: false as boolean,
            pasivos: [] as any[],
            pasivo: [] as any[],
            pasivoNuevo: [] as any[],
            clientePasivo: [] as any[],
            estado: [] as any[],
            historial: [] as any[],
            estados: []
        }),
});